import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomPagination from '../../GlobalUtilities/pagignation/custompagination';

const ListDynamicTable = ({
  columns,
  columnNames,
  data,
  totalRows,
  pageSize,
  currentPage,
  setCurrentPage,
  onRowClick,
  getData,
  onEditClick,
  onDeleteClick,
  showProceed = true,
  colorConditionColumn = null,
  colorConditionValue = null,
}) => {
  const [hoveredRowIndex, setHoveredRowIndex] = useState(null); // New state to track hovered row

  return (
    <div className="row">
      <div
        className="container"
        style={{
          overflowX: 'auto',
          width: '100%',
          boxShadow: '5px 5px 15px rgba(0,0,0,0.2)',
          borderRadius: '10px',
          padding: '16px',
        }}
      >
        <table className="table table-bordered table-hover " id="tbl">
          <thead>
            <tr> 
              {columnNames.map((name, index) => (
                <th
                  key={index}
                  scope="col"
                  style={{
                    backgroundColor: 'red',
                    color: 'white',
                    textAlign: 'center',
                  }}
                >
                  {name}
                </th>
              ))}
              {onEditClick && (
                <th scope="col" className="bg-info" style={{ backgroundColor: 'red', color: 'white', textAlign: 'center'  }}>
                  Edit
                </th>
              )}
              {onDeleteClick && (
                <th scope="col" className="bg-danger" style={{ backgroundColor: 'red', color: 'white', textAlign: 'center'  }}>
                  Delete
                </th>
              )}
              {showProceed && (
                <th
                  scope="col"
                  className="bg-success"
                  style={{ backgroundColor: 'red', color: 'white', textAlign: 'center' }}
                >
                  Proceed
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data.map((row, rowIndex) => {
              const baseRowColor =
                colorConditionColumn && row[colorConditionColumn] === colorConditionValue
                  ? { backgroundColor: '#f8d7da' } // Light red for condition match
                  : {};

              const hoverRowStyle =
                rowIndex === hoveredRowIndex ? { backgroundColor: '#D3DD00' } : {}; // Light blue on hover

              return (
                <tr
                  key={rowIndex}
                  title={row.title || ''}
                  style={{ ...baseRowColor, ...hoverRowStyle,textAlign: 'center'}}
                  onMouseEnter={() => setHoveredRowIndex(rowIndex)}
                  onMouseLeave={() => setHoveredRowIndex(null)}
                >
                  {columns.map((column, colIndex) => {
                    const cellValue = row[column];
                    return (
                      <td
                        key={colIndex}
                        style={
                          column.toLowerCase().includes('pending days')
                            ? { textAlign: 'center' }
                            : {}
                        }
                      >
                        {/* {column.toLowerCase().includes('date')
                          ? moment(cellValue, moment.ISO_8601, true).isValid()
                            ? moment(cellValue).format('DD-MMM-YYYY')
                            : ''
                          : cellValue} */}

                           {column.toLowerCase().includes('time')
                          ? moment(cellValue, moment.ISO_8601, true).isValid()
                            ? moment(cellValue).format('DD-MMM-YYYY:HH:mm:ss')
                            : ''
                          : cellValue}
                      </td>
                    );
                  })}

                  {onEditClick && (
                    <td style={{ textAlign: 'center' }}>
                      <button
                        className="btn"
                        id={`edit-${rowIndex}`}
                        title="Edit Entry"
                        onClick={() => onEditClick(row)}
                      >
                        <EditIcon sx={{ color: 'blue' }} />
                      </button>
                    </td>
                  )}
                  {onDeleteClick && (
                    <td style={{ textAlign: 'center' }}>
                      <button
                        className="btn"
                        id={`delete-${rowIndex}`}
                        title="Delete Data"
                        onClick={() => onDeleteClick(row)}
                      >
                        <DeleteIcon sx={{ color: 'red' }} />
                      </button>
                    </td>
                  )}

                  {showProceed && (
                    <td style={{ textAlign: 'center'}}>
                      <button
                        className="btn"
                        id={`proceed-${rowIndex}`}
                        title="Proceed for Entry"
                        onClick={() => onRowClick(row)}
                        style={{
                          backgroundColor: 'green',
                          color: 'white',
                          borderRadius: '50%',
                          padding: '5px',
                        }}
                      >
                        <DoneOutlineIcon sx={{ textAlign: 'center',color: 'white' }} />
                      </button>
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr className="text-center">
              <td
                colSpan={
                  columns.length +
                  (onEditClick ? 2 : 0) +
                  (onDeleteClick ? 1 : 0)
                }
              >
                {/* <CustomPagination
                  itemsCount={totalRows}
                  itemsPerPage={pageSize}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  alwaysShown={true}
                  onClick={getData}
                /> */}
              </td>
            </tr>
            <tr>
              <td
                colSpan={
                  columns.length +
                  (onEditClick ? 2 : 0) +
                  (onDeleteClick ? 1 : 0)
                }
                className="text-center"
              >
                Total {totalRows} Data
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
};

ListDynamicTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  columnNames: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired,
  totalRows: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  onRowClick: PropTypes.func,
  onEditClick: PropTypes.func,
  onDeleteClick: PropTypes.func,
  showProceed: PropTypes.bool,
  colorConditionColumn: PropTypes.string,
  colorConditionValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ListDynamicTable;
